import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import ScrollToTop from '@/components/layout/ScrollToTop';
import { Helmet } from 'react-helmet';

export default function Terms(){
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Helmet>
        <title>الشروط والأحكام - New Business</title>
        <meta name="description" content="الشروط والأحكام لاستخدام موقع New Business وخدماته." />
      </Helmet>

      <main className="container mx-auto px-4 py-16">
        <h1 className="text-2xl font-bold mb-4">الشروط والأحكام</h1>
        <p className="mb-4">مرحباً بكم في New Business. الرجاء قراءة هذه الشروط والأحكام بعناية قبل استخدام الموقع.</p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">القبول</h2>
          <p className="text-muted-foreground">باستخدامك هذا الموقع، فإنك توافق على هذه الشروط والأحكام وتشريعات الاستخدام.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">المحتوى وحقوق الملكية</h2>
          <p className="text-muted-foreground">جميع المحتويات على الموقع محمية وتعود ملكيتها إلى New Business أو المورّدين المعتمدين.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">القيود والمسؤولية</h2>
          <p className="text-muted-foreground">لا نتحمل أي مسؤولية عن الأضرار الناتجة عن استخدام الموقع بصورة غير ملائمة.</p>
        </section>

        <p className="text-sm text-muted-foreground mt-8">آخر تحديث: 17 ديسمبر 2025</p>
      </main>

      <Footer />
    </>
  );
}
